var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-right",
      attrs: { id: "search", "data-spm": "search-box" },
    },
    [
      _c("input", {
        ref: "inputRef",
        staticClass: "search-input left",
        attrs: { type: "text", "data-val": "key" },
        domProps: { value: _vm.d_val },
        on: { focus: _vm.focus, blur: _vm.blur, keydown: _vm.keydown },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "search-btn", on: { click: _vm.onSearch } }, [
        _c("i", { staticClass: "search-icon icon" }),
      ]),
      _vm._v(" "),
      _c("form", {
        staticStyle: { display: "none", width: "0", height: "0" },
        attrs: { target: "" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }